import { render, staticRenderFns } from "./MakePhotoButtonMobile.vue?vue&type=template&id=6e35245e&scoped=true&"
import script from "./MakePhotoButtonMobile.vue?vue&type=script&lang=js&"
export * from "./MakePhotoButtonMobile.vue?vue&type=script&lang=js&"
import style0 from "./MakePhotoButtonMobile.vue?vue&type=style&index=0&id=6e35245e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35245e",
  null
  
)

export default component.exports